import React from 'react';

import { Segmented } from 'antd';

import { useStatementContext } from '../StatementContext';

/**
 * ReceivableFilters
 *
 * Filter controls for receivable statements (client status, payment status, model status)
 */
const ReceivableFilters = ({ onUpdateClientStatus, onUpdatePaymentStatus, onUpdateModelStatus }) => {
    const { filters, contactType } = useStatementContext();

    return (
        <div className="statement-filters">
            <div className="statement-filter">
                <small>client invoice status</small>
                <Segmented
                    value={filters.clientStatus}
                    onChange={onUpdateClientStatus}
                    size="small"
                    options={[
                        { label: 'All', value: 'All' },
                        { label: 'Billable', value: 'Billable' },
                        { label: 'Locked', value: 'Locked' },
                        { label: 'Invoiced', value: 'Invoiced' },
                    ]}
                />
            </div>
            <div className="statement-filter">
                <small>client payment</small>
                <Segmented
                    value={filters.paymentStatus}
                    onChange={onUpdatePaymentStatus}
                    size="small"
                    options={[
                        { label: 'All', value: 'All' },
                        { label: 'Not Paid', value: 'NotPaid' },
                        { label: 'Paid', value: 'Paid' },
                    ]}
                />
            </div>
            {contactType !== 'agency' && (
                <div className="statement-filter">
                    <small>model payment</small>
                    <Segmented
                        value={filters.modelStatus}
                        onChange={onUpdateModelStatus}
                        size="small"
                        options={[
                            { label: 'All', value: 'All' },
                            { label: 'Not Paid', value: 'NotPaid' },
                            { label: 'Paid', value: 'Paid' },
                        ]}
                    />
                </div>
            )}
        </div>
    );
};

export default ReceivableFilters;

